if (!customElements.get('product-media')) {
  class ProductMedia extends HTMLElement {
    constructor() {
      super();

      const originalPopupContent = this.querySelector('[data-product-media-popup-content]') ? this.querySelector('[data-product-media-popup-content]').innerHTML : null;

      this.addEventListener('click', (event) => this.updatePopupContent(event, originalPopupContent));
      this.swiperInit();
      this.popupInit(originalPopupContent);

      setTimeout(() => {
        this.classList.add('product-media--ready');
      }, 200);
    }

    swiperInit() {
      const swiperElement = this.querySelector('[data-swiper]');

      if (!swiperElement) { return; }

      let currentOption1 = null;
      const wrapper = this.querySelector('[data-swiper-wrapper]');
      const originalSlides = wrapper.innerHTML;
      const prevButton = swiperElement.querySelector('[data-swiper-prev]');
      const nextButton = swiperElement.querySelector('[data-swiper-next]');
      const pagination = swiperElement.querySelector('[data-swiper-pagination]');
      const pause = swiperElement.querySelector('[data-swiper-pause]');
      const loop = swiperElement.hasAttribute('data-swiper-loop');

      const swiper = new window.Swiper(swiperElement, {
        spaceBetween: 0,
        slidesPerView: 1,
        autoHeight: true,
        draggable: true,
        loop: loop,
        threshold: 20,
        navigation: {
          prevEl: prevButton,
          nextEl: nextButton
        },
        pagination: {
          el: pagination,
          clickable: true
        },
        autoplay: {
          delay: 6000,
          disableOnInteraction: false
        }
      });

      if (pause) {
        pause.addEventListener('click', () => {
          swiperElement.classList.toggle('swiper-paused');
          pause.classList.toggle('active');

          if (pause.classList.contains('active')) {
            swiper.autoplay.stop();
          } else {
            swiper.autoplay.start();
          }
        });
      }

      swiper.on('slideChangeTransitionStart', () => {
        swiper.update();

        if (!swiperElement.classList.contains('swiper-paused')) {
          swiper.autoplay.start();
        }

        this.stopVideos();

        updateAvatar();

        const paginationItems = pagination.querySelectorAll('.swiper-pagination-bullet');

        if (paginationItems.length) {
          paginationItems.forEach((paginationItem, index) => {
            if (swiper.activeIndex > paginationItems.length) {
              paginationItem.classList.remove('swiper-pagination-bullet--filled');
            } else {
              if (index + 1 < swiper.activeIndex) {
                paginationItem.classList.add('swiper-pagination-bullet--filled');
              } else {
                paginationItem.classList.remove('swiper-pagination-bullet--filled');
              }
            }
          });
        }
      });

      updateAvatar();

      function updateAvatar() {
        const activeSlide = swiperElement.querySelector('.swiper-slide-active');

        if (activeSlide) {
          const slideImage = activeSlide.querySelector('[data-product-media-image]');
          const avatarWrapper = swiperElement.querySelector('[data-swiper-avatar-wrapper]');
          const avatar = swiperElement.querySelector('[data-swiper-avatar]');
          const avatarText = swiperElement.querySelector('[data-swiper-avatar-text]');
          const zoom = swiperElement.querySelector('[data-popup-link]');

          if (zoom) {
            if (slideImage) {
              zoom.setAttribute('data-image-id', slideImage.getAttribute('data-image-id'));
              zoom.classList.remove('d-none');
            } else {
              zoom.classList.add('d-none');
            }
          }

          if (avatarWrapper) {
            if (slideImage && slideImage.hasAttribute('data-variant-title')) {
              avatarWrapper.classList.remove('d-none');
              avatar.setAttribute('src', slideImage.getAttribute('src'));
              avatarText.innerHTML = slideImage.getAttribute('data-variant-title') ? slideImage.getAttribute('data-variant-title') : '';
            } else {
              avatarWrapper.classList.add('d-none');
            }
          }
        }
      }

      window.addEventListener('resize', () => {
        swiper.update();
      });

      swiper.on('slideChangeTransitionEnd', () => {
        const slides = wrapper.querySelectorAll('[data-swiper-slide]');

        if (!slides.length) { return; }

        let activeModelSlide = false;

        slides.forEach((slide) => {
          if (slide.classList.contains('swiper-slide--model') && slide.classList.contains('swiper-slide-active')) {
            const shopifyXRButton = this.querySelector('[data-shopify-xr]');

            if (shopifyXRButton) {
              shopifyXRButton.setAttribute('data-shopify-model3d-id', slide.querySelector('product-model').getAttribute('data-id'));
            }

            activeModelSlide = true;
          }
        });

        if (activeModelSlide) {
          swiper.allowTouchMove = false;
          swiper.autoplay.stop();
        } else {
          swiper.allowTouchMove = true;
        }
      });

      this.addEventListener('click', (event) => {
        if (!event.target.hasAttribute('data-video-play-button')) { return; }
        swiper.autoplay.stop();
      });

      this.addEventListener('updateVariant', (event) => {
        if (this.hasAttribute('data-update-variant-images')) {
          if (currentOption1 === event.detail.option1) { return; }

          currentOption1 = event.detail.option1;
          wrapper.innerHTML = originalSlides;

          const newSlides = wrapper.querySelectorAll('[data-swiper-slide]');

          if (!newSlides.length) { return; }

          newSlides.forEach((newSlide, index) => {
            const option1Value = newSlide.getAttribute('data-option-1-value');

            if (option1Value !== event.detail.option1) {
              newSlide.remove();
            }

            if (index === (newSlides.length - 1)) {
              swiper.loopCreate();
              swiper.update();
              swiper.slideTo(1, 1, false);
            }
          });
        } else {
          if(!this.classList.contains('product-media--ready')) { return; }

          const swiperSlides = wrapper.querySelectorAll('[data-swiper-slide]');

          swiperSlides.forEach((swiperSlide, index) => {
            const slideId = parseInt(swiperSlide.getAttribute('data-slide-id'), 10);

            if (event.detail.featured_media && slideId !== event.detail.featured_media.id) { return; }

            swiper.slideTo(index);
          });
        }
      });

      return swiper;
    }

    popupInit(originalPopupContent) {
      let currentOption1 = null;
      const popupContent = this.querySelector('[data-product-media-popup-content]');

      if (!popupContent) { return; }

      this.addEventListener('updateVariant', (event) => {
        if (this.hasAttribute('data-update-variant-images')) {
          if (currentOption1 === event.detail.option1) { return; }

          currentOption1 = event.detail.option1;

          popupContent.innerHTML = originalPopupContent;

          const newImages = popupContent.querySelectorAll('[data-product-media-popup-image]');

          if (!newImages.length) { return; }

          newImages.forEach((newImage) => {
            const option1Value = newImage.getAttribute('data-option-1-value');

            if (option1Value === event.detail.option1) { return; }

            newImage.remove();
          });
        }
      });
    }

    updatePopupContent(event, originalPopupContent) {
      if (!event.target.hasAttribute('data-popup-link')) { return; }

      const popupContent = this.querySelector('[data-product-media-popup-content]');

      if (this.hasAttribute('data-update-variant-images')) {
        originalPopupContent = popupContent.innerHTML;
      }

      popupContent.innerHTML = originalPopupContent;

      const imageId = event.target.getAttribute('data-image-id');
      const newImages = popupContent.querySelectorAll('[data-product-media-popup-image]');

      if (!newImages.length) { return; }

      newImages.forEach((newImage) => {
        const newImageId = newImage.getAttribute('data-image-id');

        if (newImageId !== imageId) { return; }

        newImage.remove();

        popupContent.prepend(newImage);
      });
    }

    stopVideos() {
      this.playButtons = this.querySelectorAll('[data-video-play-button]');
      this.videoWrappers = this.querySelectorAll('[data-video-wrapper]');

      if (this.playButtons) {
        this.playButtons.forEach((playButton) => {
          playButton.classList.remove('d-none');
        });
      }

      if (this.videoWrappers) {
        this.videoWrappers.forEach((videoWrapper) => {
          videoWrapper.classList.add('d-none');

          const videoIframe = videoWrapper.querySelector('iframe');
          const videoElement = videoWrapper.querySelector('video');

          if (videoIframe) {
            const videoIframeSrc = videoIframe.getAttribute('data-src');

            videoIframe.setAttribute('src',`${videoIframeSrc}?autoplay=0`);
          } else if (videoElement) {
            videoElement.pause();
          }
        });
      }
    }
  }

  customElements.define('product-media', ProductMedia);
}